import Day from './day';
import Staff from './staff';
import Category from './category';

export default { Day, Staff, Category };
